module.exports = __webpack_public_path__ + "assets/518ae86d9748472118d0eacf204b85a4.svg";